import { Link } from 'react-router-dom';
import fileIcon from '../assets/file.png';
import githubIcon from '../assets/github.png';
import './DocsPage.css';
import logo from '../assets/logo_copiaazul.png';
import { CSSTransition } from 'react-transition-group';
import '../styles/Transitions.css';

const DocsPage = () => {
  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={400}
      classNames="page-transition"
    >
      <div className="docs-container">
        <nav className="nav-bar">
          <div className="nav-brand">
            <Link to="/" className="brand-link">
              <img src={logo} alt="WCAIS Logo" className="nav-logo" />
              <span className="nav-title" style={{
                background: 'linear-gradient(to bottom, #ffffff, #66f2f2)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: 'inline-block'
              }}>What-can-AI-see?</span>
            </Link>
          </div>

          <Link to="/app" className="get-started-btn">Get started</Link>
        </nav>

        <div className="docs-content">
          <div className="markdown-content">
            <h1>What-can-AI-see?</h1>
            
            <p><strong>AI-Powered Visual Assistant for the Visually Impaired</strong></p>

            <p>Welcome to <strong>What-can-AI-see?</strong>, an innovative tool designed to help visually impaired individuals understand their surroundings through advanced AI vision technology. Our platform combines state-of-the-art image recognition with natural language processing to provide clear, accurate descriptions of the visual world.</p>

            <hr />

            <h2><strong>About the Project</strong></h2>

            <p><strong>What-can-AI-see?</strong> is an intelligent assistant designed to bridge the gap between visual content and accessibility. It leverages cutting-edge computer vision and natural language processing to provide real-time descriptions of images and surroundings, making the visual world more accessible to everyone.</p>

            <p>The system utilizes advanced AI techniques including:</p>

            <ul>
              <li><strong>Vision Transformers</strong> for comprehensive image analysis</li>
              <li><strong>Natural Language Generation</strong> for clear, contextual descriptions</li>
              <li><strong>Real-time Processing</strong> for immediate feedback</li>
              <li><strong>Voice Interface</strong> for hands-free operation</li>
              <li><strong>Adaptive Learning</strong> to improve accuracy over time</li>
            </ul>

            <p>Unlike generic image recognition tools, <strong>What-can-AI-see?</strong> is specifically designed for accessibility, implementing specialized features:</p>

            <ul>
              <li>Context-aware scene description</li>
              <li>Priority-based object detection</li>
              <li>Natural language responses</li>
              <li>Voice-activated controls</li>
              <li>Real-time processing</li>
            </ul>

            <hr />

            <h2>Key Features</h2>

            <ul>
              <li><strong>Real-time Image Analysis</strong>
                <ul>
                  <li>Advanced object detection</li>
                  <li>Scene understanding</li>
                  <li>Facial expression recognition</li>
                  <li>Color and pattern detection</li>
                </ul>
              </li>
              <li><strong>Voice Interface</strong>
                <ul>
                  <li>Natural language interaction</li>
                  <li>Voice-activated commands</li>
                  <li>Clear audio feedback</li>
                </ul>
              </li>
              <li><strong>Accessibility Features</strong>
                <ul>
                  <li>High-contrast interface</li>
                  <li>Screen reader compatibility</li>
                  <li>Customizable feedback</li>
                  <li>Intuitive navigation</li>
                </ul>
              </li>
              <li><strong>Performance</strong>
                <ul>
                  <li>Fast response times</li>
                  <li>Accurate descriptions</li>
                  <li>Battery efficient</li>
                  <li>Offline capabilities</li>
                </ul>
              </li>
            </ul>

            <hr />

            <h2><strong>Why Choose What-can-AI-see?</strong></h2>

            <ul>
              <li><strong>Accessibility:</strong> Designed specifically for visually impaired users</li>
              <li><strong>Accuracy:</strong> Powered by state-of-the-art AI models</li>
              <li><strong>Ease of Use:</strong> Simple, intuitive voice interface</li>
              <li><strong>Privacy:</strong> Local processing of sensitive data</li>
              <li><strong>Reliability:</strong> Works in various lighting conditions</li>
              <li><strong>Community:</strong> Growing network of users and supporters</li>
            </ul>

            <div className="more-info">
              <p>For more detailed information, visit our</p>
              <a 
                href="https://github.com/DanielMiller2000/What-can-AI-see" 
                target="_blank" 
                rel="noopener noreferrer"
                className="github-link"
              >
                <img src={githubIcon} alt="GitHub Repository" className="github-icon" />
                GitHub Repository
              </a>
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default DocsPage; 